import React from 'react';
import './LandingSections.css';

const TrainingTracks = () => {
  return (
    <section className="training-tracks-section">
      <div className="container">
        <div className="track-item">
          <h3>Beginner Track</h3>
          <p className="elo-range">0 - 800 ELO</p>
          <p className="quote">"I keep losing pieces and feel overwhelmed. I don't know what to do after the first few moves."</p>
          <ul>
            <li>We take you from learning what a <strong>Rook</strong> is to confidently winning your first few games.</li>
            <li>Focused lessons on basic checkmate patterns, tactical vision, and simple, safe opening systems.</li>
            <li>Build the foundational confidence and discipline necessary for long-term growth.</li>
          </ul>
        </div>

        <div className="track-item">
          <h3>Intermediate Accelerator</h3>
          <p className="elo-range">800 - 1800 ELO</p>
          <p className="quote">"I'm stuck in an ELO rut and have plateaued. I know the theory but can't translate it into wins."</p>
          <ul>
            <li><strong>Game Breakdown & Analysis:</strong> We ruthlessly <strong>assess loopholes</strong> in your strategies by analyzing your games, showing where advantages were lost.</li>
            <li>Deep dives into <strong>Mid-Game Concepts</strong>, positional play, and executing complex themes like the <strong>Positional Sacrifice</strong>.</li>
            <li>Learn from the greats through curated master game studies to master advanced techniques.</li>
          </ul>
        </div>

        <div className="track-item">
          <h3>Advanced Masterclass</h3>
          <p className="elo-range">1800+ ELO</p>
          <p className="quote">"I'm a well-aware player, but subtle inaccuracies and small blunders keep me from tournament success."</p>
          <ul>
            <li><strong>Precision Training:</strong> Focus on minimizing those small, subtle mistakes that keep you from excelling at the highest levels.</li>
            <li>Advanced opening repertoire building, complex calculation drills, and deep engine validation.</li>
            <li>Guidance on tournament psychology, time management, and achieving titled play.</li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default TrainingTracks;
